import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowNarrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 12H20M4 12L8 8M4 12L8 16",
		stroke: "#363636",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowNarrowLeft;
